var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: [],
    overwriteSelected: [],
    isOverwriteData: false,
    isOverwriteSelected: false,
};
var tableSlice = createSlice({
    name: 'tableCommon',
    initialState: initialState,
    reducers: {
        overwriteTableData: function (state, action) {
            state.data = action.payload.data;
        },
        clearOverwriteTableData: function (state) {
            state.data = [];
            state.overwriteSelected = [];
            state.isOverwriteData = false;
        },
        overwriteTableSelected: function (state, action) {
            state.overwriteSelected = action.payload.overwriteSelected;
            state.isOverwriteSelected = action.payload.isOverwriteSelected;
        },
    },
});
export var overwriteTableData = (_a = tableSlice.actions, _a.overwriteTableData), clearOverwriteTableData = _a.clearOverwriteTableData, overwriteTableSelected = _a.overwriteTableSelected;
export default tableSlice.reducer;
